module["exports"] = [
  "#{city_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/address/city.js
 ** module id = 841
 ** module chunks = 0
 **/